import { useMemo } from 'react';

import { Scope } from '@atlassian/search-client';
import type { SearchResource } from '@atlassian/search-provider';
import { createSearchProvider } from '@atlassian/search-provider';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export function useSearchProvider(): Promise<SearchResource> {
	const { cloudId } = useSessionData();
	return useMemo(
		() =>
			Promise.resolve(
				createSearchProvider(cloudId, Scope.ConfluencePageBlog, undefined, undefined, true),
			),
		[cloudId],
	);
}
